export default {
  index: {
    title: '請選擇存款方式',
    tip: '請選擇存款方式並按照以下流程上傳存款憑證',
    sub_title: '不支持第三方存款',
    online_bank_deposit: '網上銀行轉賬',
    atm_transfer_deposit: 'ATM 轉賬',
    bank_transfer_deposit: '銀行櫃檯轉賬',
    cheque_deposit: '支票存款',
    fps_deposit: 'FPS轉數快',
    sub_account_deposit: '子賬戶存款',
    noDeposit: '無存款記錄'
  },
  steps: {
    step_one: '步驟1',
    step_two: '步驟2',
    step_three: '步驟3',
    step_four: '步驟4',
    step_five: '步驟5',
    // 網上銀行轉賬
    online_stepCon_one: '登陸個人網上銀行網頁或APP',
    online_stepCon_two: '選擇轉賬服務',
    online_stepCon_three: '正確填寫及檢查轉賬申請資料:</br>',
    online_stepCon_four:
      '確認轉賬申請並截圖保存已成功轉賬確認頁面作為匯款憑證 – 必需清楚顯示以下資料:',
    online_stepCon_four_list: [
      'a.存款日期',
      'b.存款金額',
      'c.支賬銀行名稱及賬戶',
      'd.入賬銀行名稱及賬戶',
      'e.轉賬確認編號'
    ],
    online_stepCon_five: '提交存款申請並上傳匯款憑證',
    // ATM 轉賬
    atm_stepCon_one: '登陸ATM自動櫃員機',
    atm_stepCon_two: '使用轉賬服務',
    atm_stepCon_three: '提供正確及檢查轉賬申請資料:</br>',
    atm_stepCon_four: '必須取得轉賬單據作為匯款憑證– 必需清楚顯示以下資料:',
    atm_stepCon_four_list: [
      'a.存款日期',
      'b.存款金額',
      'c.支賬銀行名稱及賬戶',
      'd.入賬銀行名稱及賬戶',
      'e.轉賬確認編號'
    ],
    atm_stepCon_five: '提交存款申請並上傳匯款憑證',
    // 銀行轉賬
    counter_stepCon_one: '前往銀行櫃檯進行匯款申請',
    counter_stepCon_two:
      '申請匯款至艾德證券期貨有限公司的指定銀行賬戶 (不接受存入現金, 請由客戶的個人銀行賬戶轉賬至艾德證券期貨)</br>',
    counter_stepCon_three:
      '取得匯款憑證，請確保收據上清楚顯示存入的金額、日期、匯款人及收款人資料',
    counter_stepCon_four: '提交存款申請並上傳匯款憑證',
    // 支票存款
    cheque_stepCon_one:
      '支票抬頭請填寫「艾德證券期貨有限公司」 或 “Eddid Securities and Futures Limited”',
    cheque_stepCon_two:
      '存入支票前先複印或拍攝支票作為匯款憑證，請確保複印本上已清楚顯示銀行賬戶持有人姓名及賬號',
    cheque_stepCon_three:
      '往銀行櫃檯或「存支票機」存入支票，向銀行提供艾德證券期貨有限公司的銀行資料',
    cheque_stepCon_four:
      '取得支票存款收據作為匯款憑證，請確保收據上清楚顯示存入的金額、日期及支票號碼(若以「存支票機」存入支票，請先將收據放大復印及調深顏色，以便核對支票上的銀行資料。)',
    cheque_stepCon_five:
      '提交存款申請並上傳匯款憑證，請詳閱<a href="https://www.eddid.com.hk/deposit-and-withdrawal/?ss_menu_cn=%E6%B8%AF%E7%BE%8E%E8%82%A1%E8%B3%87%E9%87%91%E5%AD%98%E5%85%A5%E5%8F%8A%E6%8F%90%E5%8F%96&ss_menu_name=zj_gmgsfbz" target="_blank">「支票存款注意事項」</a>',
    // FPS-轉數快
    FPS_stepCon_one:
      '以轉數快（FPS）轉賬至艾德FPS識別碼：</br>證券:100067040(HSBC滙豐銀行)</br>期貨:165544362(HSBC滙豐銀行)</br>基金:100067040(HSBC滙豐銀行)',
    FPS_stepCon_two:
      '將交易紀錄截屏存檔（需清楚顯示<span style="color: #ffbe37;">‌客戶銀行賬戶號碼</span>‌及<span style="color: #ffbe37;">匯款日期</span>‌）',
    FPS_stepCon_three: '提交存款申請並上傳存款憑證',
    // 子賬戶存款
    subAccount_stepCon_one: '登陸個人網上銀行網頁或APP',
    subAccount_stepCon_two: '選擇轉賬服務',
    subAccount_stepCon_three: '正確填寫子賬戶資料',
    subAccount_stepCon_four:
      '確認轉賬申請並截圖保存已成功轉賬確認頁面作為匯款憑證 – 必需清楚顯示以下資料:</br>' +
      'a.存款日期</br>' +
      'b.存款金額</br>' +
      'c.支賬銀行名稱及賬戶</br>' +
      'd.入賬銀行名稱及賬戶</br>' +
      'e.轉賬確認編號',
    subAccount_stepCon_five: '提交存款申請並上傳匯款憑證'
  },
  note:
   `1. 7×24 小時存款服務：包括 eDDA 存款、符合 FPS 7×24 存款指引的存款、使用已完成認證的登記銀行或指定銀行賬戶存款至艾德證券期貨有限公司（「本公司」）滙豐賬戶的港幣存款。 <br />
    2. 除上述 7×24 小時存款服務外，其餘存款辦理時間如下：客戶於星期一至五（香港公衆假期、聖誕前夕、除夕及農曆新年前夕除外）15:00 前存入資金並提交存款證明，存款將於當天辦理完成；其後收到的存款申請，將於下一個工作日處理。 <br />
    3. 本公司無法保證所有7×24小時存款申請均能即時完成。未能即時完成辦理的存款申請，將於工作日辦公時間內由專人跟進處理。 <br />
    4、結單顯示規則 <br />
    （以下均為香港時間） <br />
    <span style="color:#333;font-weight:500;">(I) 證券/基金賬戶：</span>客戶於每日16:59或之前辦理完成的存款將反映在當日的結單；其後完成的存款將顯示在下一交易日的結單。 <br />
    <span style="color:#333;font-weight:500;">(II) 期貨賬戶：</span> <br />
    <span style="color:#333;font-weight:500;">美東夏令時間：</span> <br />
    客戶於星期一至五（元旦除外）05:00至翌日04:59期間辦理完成的存款將反映在當日的結單；於星期六04:59後辦理完成的存款將顯示在下一交易日的結單。 <br />
    <span style="color:#333;font-weight:500;">美東冬令時間：</span> <br />
    客戶於星期一至五（元旦除外）06:00至翌日05:59期間辦理完成的存款將反映在當日的結單；於星期六05:59後辦理完成的存款將顯示在下一交易日的結單。 <br />
    備註：若存款於每年元旦當日辦理完成，相關記錄將顯示在下一交易日的結單。 <br />
    <span style="color:#333;font-weight:500;">(III) 槓桿式外匯賬戶：</span> <br />
    <span style="color:#333;font-weight:500;">美東夏令時間：</span> <br />
    客戶於星期一至五05:05至翌日04:55期間辦理完成的存款將反映在當日的結單；於星期六04:55後辦理完成的存款將顯示在下一交易日的結單。 <br />
    <span style="color:#333;font-weight:500;">美東冬令時間：</span> <br />
    客戶於星期一至星期五當日06:05至翌日05:55期間辦理完成的存款將反映在當日的結單；於星期六05:55後辦理完成的存款將顯示在下一交易日的結單。 <br />
    5. 本公司不接受第三者轉賬或存款，銀行賬戶持有人或匯款人的姓名必須與本公司賬戶持有人的姓名相同。如客戶從未提供該匯款銀行賬戶之銀行證明，請附上有關銀行賬戶證明，如銀行月結單、提款卡、銀行存摺首頁複印本等，該等證明文件必須清楚顯示賬戶持有人的姓名及銀行賬號以核對存款者身份。 <br />
    6. 如存款涉及特快轉賬(CHATS)、電匯及本地銀行非港幣的轉賬，匯出銀行、中轉銀行和收款銀行有可能收取相應的手續費，具體費用請以銀行實際收取為準。 <br />
    7. 本公司不接受任何現金存款，如客戶欲存入現金，請先將現金存入銀行賬戶，再由客戶的銀行賬戶轉賬至本公司之銀行賬戶。 <br />
    8. 本公司不能保證接收或處理現金存款或來自任何第三者之款項。 <br />
    9. 客戶存款時請填寫正確的賬戶名稱，填寫錯誤將導致匯款被銀行退回或產生費用，本公司概不負責。 <br />
    10. 如有任何查詢，請致電+852 2655 0338 / 400 120 0068（中國內地免費熱線） 或電郵 cs@eddidsec.com與本公司聯絡。`,
    chequeNote:
    '<div style="color:#333;font-weight:500;margin-bottom:5px">存入資金前, 請詳閱存入資金注意事項：<div>' +
    '1、存款處理時間為香港時間星期一至五上午九時至下午三時（香港公眾假期除外）。如我們在以上時間內收到您的資金及存款證明，存款將於一個工作天內存入您的交易賬戶。 </br>' +
    '2、所有於下午三時後收到的款項及存款收據，將於下一個工作天處理。 </br>' +
    '3、相同銀行轉賬豁免手續費；經跨行轉賬，閣下銀行有可能征收手續費。 </br>' +
    '4、艾德證券期貨有限公司不接受第三者轉賬或存款，銀行賬戶持有人或匯款人的姓名必須與艾德證券賬戶持有人的姓名相同。 </br>' +
    '5、艾德證券不接受任何現金存款，如您持有現金，請先將現金存入您的銀行賬戶，再由閣下的銀行賬戶轉賬至艾德證券的銀行賬戶。 </br>' +
    '6、艾德證券不能保證接收、處理或退回現金存款或來自任何第三者之款項。 </br>' +
    '7、艾德證券保留將資金退回存款來源的權利，及艾德證券不保證某些提款選項。 </br>' +
    '8、如欲索取進一步資料，請致電+852 2655 0338 / 400 120 0068（中國內地免費熱線） 或電郵 cs@eddidsec.com 與艾德證券聯絡。 </br>' +
    '9、匯款時請填寫正確的賬戶名稱，填寫錯誤將導致匯款被銀行退回，因此產生的費用將由閣下自行承擔。 </br>' +
    '<div style="color:#333;font-weight:500;padding-top:10px;margin-bottom:5px">反洗錢警告：</div>' +
    '如客戶的交易賬戶在存款後沒有進行正常交易活動後作出提款申請，已有可能涉及洗錢活動。艾德證券期貨有可能將賬戶停用或取消。 ',
  note_FPS:
    '<div style="color:#333;font-weight:500;margin-bottom:5px">存入資金前, 請詳閱存入資金注意事項：</div>' +
    '1、存款處理時間： 如閣下於星期一至五（香港公眾假期、聖誕前夕、除夕及農曆新年前夕除外）下午3時前存入資金並提交存款證明，存款將於當天辦理完成；其他時間收到之存款申請將於下一個工作天處理。 </br>' +
    '2、不接受第三者轉賬或存款，銀行賬戶持有人或匯款人的姓名必須與艾德證券賬戶持有人的姓名相同。如未曾提供該匯款銀行賬戶銀行證明，請附上有關銀行賬戶證明文件，如銀行月結單、提款卡、銀行存摺首頁複印本等，該等文件必須清楚顯示賬戶持有人的姓名及銀行賬號以核對存款者身份。 </br>' +
    '3、艾德證券期貨不能保證接收、處理或退回現金存款或來自任何第三者之款項。 </br>' +
    '4、艾德證券期貨保留將資金退回存款來源的權利，並且不保證某些提款選項。 </br>' +
    '5、如有任何查詢，請致電+852 2655 0338 / 400 120 0068（中國內地免費熱線） 或電郵 cs@eddidsec.com 與我們聯絡。 </br>' +
    '6、汇款时请填写正确的账户名称，填写错误将导致汇款被银行退回，因此产生的费用将由阁下自行承担。 </br>' +
    '<div style="color:#333;font-weight:500;padding-top:10px;margin-bottom:5px">反洗錢警告：</div>' +
    '如客戶的交易賬戶在存款後沒有進行正常交易活動後作出提款申請，已有可能涉及洗錢活動。艾德證券期貨有可能將賬戶停用或取消。 ',
  type: {
    notice: '請閱讀存款注意事項，並按以下流程辦理匯款申請。 ',
    up_button: '上傳存款收據'
  },
  upload: {
    please_sel: '請選擇',
    account_number: '交易賬號',
    bank_card_number: '匯款銀行賬號',
    deposit_amount: '存款金額',
    eddid_bank: '艾德收款賬號',
    upload_transfer_voucher: '上傳轉賬憑證',
    upload_bank_proof: '上傳銀行證明',
    submit: '提交',
    please_input: '請輸入存款金額',
    please_input_other_bank_name: '請輸入其他銀行名稱',
    please_input_other_bank_card: '請輸入其他銀行賬號',
    please_input_correct_bank_card: '請輸入正確的銀行卡號',
    other_bank_name: '其他銀行名稱',
    other_bank_card: '其他銀行賬號',
    back_card_verify: '請選擇一個銀行賬號',
    remittance_amount_verify: '請填寫正確的匯款金額',
    eddid_account_verify: '請選擇艾德賬戶',
    upload_image_verify_isNull: '請上傳存款證明',
    upload_bank_verify_isNull: '請上傳銀行證明',
    upload_image_verify_size: '上傳圖片不能超過5M',
    upload_image_verify_type: '僅接受JPG，PNG，PDF，JPEG格式',
    haveRead: '本人已閱讀，知悉及明白「存款相關費用明細」',
    depositTipsTitle: '存款相關費用明細',
    depositTips: {
      wireTransfer: {
        title: '電匯費用 (銀行收取)',
        tips:
          '如客戶以非本地銀行戶口以電匯方式存款到公司的本地銀行戶口, 銀行有可能收取電匯費用, 視乎有關銀行的政策而訂。客戶需向其匯款銀行查詢。 '
      },
      other: {
        title: '其他收費 (銀行收取)',
        tips:
          '銀行有可能收費行政費用, 視乎有關銀行的政策而訂。客戶需向其匯款銀行查詢。 '
      },
      exchangePriceDifferenceBank: {
        title: '兌換差價 (銀行收取)',
        tips:
          '如客戶存款貨幣與本公司的銀行戶口貨幣不同, 當中可能產生兌換差價。 ',
        example:
          '如:客戶存入人民幣到本公司的美元銀行戶口，銀行會以其匯率兌換客戶之人民幣至美元，當中可能產生兌換差價。客戶需向其匯款銀行查詢。 '
      },
      exchangePriceDifferenceCompany: {
        title: '兌換差價 (本公司收取)',
        tips:
          '如客戶存款貨幣與其交易賬戶結算貨幣不同,本公司會以本公司適用的銀行匯率兌換其存款為交易賬戶結算貨幣後進行存款, 過程中有可能產生兌換差價。 ',
        example:
          '如: 客戶交易賬戶以美元作為結算貨幣，所有港元/人民幣存款將會以本公司適用的銀行匯率兌換成美元顯示於您的交易賬戶內。 '
      }
    }
  },
  dialog: {
    success: '您的存款申請已成功提交，如有問題請與我們聯繫',
    title: '您的申請編號是',
    prompt: '我們會盡快處理你的申請，',
    button: '確定'
  },
  bankAccount: {
    eddid_bank_account: '艾德銀行賬戶',
    FPS_code: '艾德轉數快識別碼'
  },
  depositWay: {
    online_bank_deposit: 'ONLINE BANK DEPOSIT'
  },
  saveHK: '存入港幣',
  saveUSD: '存入美元',
  saveRMB: '存入人民幣',
  payee_number: '收款人賬戶號碼',
  account_name: '賬戶名稱',
  bank_number: '銀行卡號',
  payee_name: '收款人姓名',
  swift_code: 'SWIFT 代碼',
  bank_address: '收款人銀行地址',
  identifier: '識別碼',
  HKD: '港幣',
  USD: '美元',
  CNY: '人民幣',
  receiveBankName: '收款銀行',
  bankCode: '銀行編號',
  receiveName: '收款人名稱',
  beneficiaryAccount: '收款人賬戶',
  fpsInfo:
    '通過FPS存款時，請務必於客戶匯款銀行FPS轉賬界面備註欄填寫客戶於艾德證券期貨的交易賬戶號碼，否則會影響客戶的存款到賬。',
  hsbcInfo:
    '另外，客戶通過FPS存款至艾德證券期貨HSBC FPS收款賬戶，只需於客戶匯款銀行完成FPS轉賬即可，無需在此處上傳憑證，我們收到客戶的存款後會通過郵件通知客戶。',
  fpsnum: '轉賬識別碼',
  fpsWarn:
    '請於FPS轉賬頁面中「致收款人信息」欄內填入此號碼',
  othertext: '其他銀行',
  edAccNum: '艾德交易賬戶號碼',
  requirements_deposit: '為符合監管機構要求，客戶如欲使用新綁定之銀行賬戶或其他未綁定之銀行賬戶存款，則其首次存款數額不可少於10,000港元或等值的貨幣，否則艾德證券期貨有機會未能處理閣下的存款。',
  requirements_account: '為符合監管機構要求，客戶如欲使用其他未綁定之銀行賬戶存款，則其首次存款數額不可少於10,000港元或等值的貨幣，否則艾德證券期貨有機會未能處理閣下的存款。',
  requirements_bank: '為符合監管機構要求，客戶如欲使用其他新綁定之銀行賬戶存款，則其首次存款數額不可少於10,000港元或等值的貨幣，否則艾德證券期貨有機會未能處理閣下的存款。',
  fpsDepositProcess: `<div style="color:#333;font-weight:500;margin-bottom:5px">轉數快（FPS）存款流程</div>
    <div style="color:#333;font-weight:500;margin-bottom:5px">如透過轉數快轉賬至滙豐銀行，請於FPS轉賬頁面「致收款人信息」欄填寫艾德交易賬戶號碼。如沒有填寫，請致電客戶服務熱線 +852 2655 0338 / 400 120 0068（中國內地免費熱線）與我們確認款項。</div>
    <div style="color:#333;font-weight:500;margin-bottom:5px">1. [證券或基金]</div>
    轉數快識別碼：100067040 </br>
    收款銀行：滙豐銀行 HSBC </br>
    收款人名稱: EDDID SECURITIES AND FUTURES LTD – CLIENTS ACCOUNT-SECURITIES(FPS) </br>
    <div style="color:#333;font-weight:500;margin-bottom:5px">2. [期貨]</div>
    轉數快識別碼：165544362 </br>
    收款銀行：滙豐銀行 HSBC </br>
    收款人名稱: EDDID SECURITIES AND FUTURES LIMITED - CLIENTS' ACCOUNT (FUTURES) (HKFE Trade) (FPS)`
}
